import "bootstrap/dist/css/bootstrap.min.css";
import AppRoutes from "./routes/Routes";
import ContextContainer from "./context";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      <ContextContainer>
        <AppRoutes />
      </ContextContainer>
    </Router>
  )
}

export default App;
